// src/Components/Toast.js
import React, { useEffect } from 'react';

const TYPE_CONFIG = {
  success: {
    borderColor: '#22c55e',
    iconColor: '#22c55e',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 13l4 4L19 7" />
      </svg>
    ),
  },
  error: {
    borderColor: '#1d4ed8',
    iconColor: '#1d4ed8',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
  },
  info: {
    borderColor: '#0891b2',
    iconColor: '#0891b2',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
};

export default function Toast({ message, type = 'info', isVisible, onClose }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const config = TYPE_CONFIG[type] ?? TYPE_CONFIG.info;

  return (
    <div
      className="animate-slide-in"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 9999,
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          borderLeft: `4px solid ${config.borderColor}`,
          padding: '14px 16px',
          minWidth: '280px',
          maxWidth: '420px',
        }}
      >
        {/* Type icon */}
        <span
          style={{
            flexShrink: 0,
            color: config.iconColor,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {config.icon}
        </span>

        {/* Message */}
        <p
          style={{
            flex: 1,
            margin: 0,
            fontSize: '14px',
            fontWeight: 500,
            color: '#111111',
            lineHeight: 1.4,
          }}
        >
          {message}
        </p>

        {/* Close button */}
        <button
          onClick={onClose}
          aria-label="Dismiss notification"
          style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 'none',
            padding: '4px',
            borderRadius: '6px',
            cursor: 'pointer',
            color: '#9ca3af',
            transition: 'color 0.15s, background 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#111111';
            e.currentTarget.style.background = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#9ca3af';
            e.currentTarget.style.background = 'none';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
